module.exports = __webpack_public_path__ + "static/media/Winona_Portrait.8c202144.png";